<template>
	<div class="p-3-mobile">
		<div class="box">
			<div class="is-size-5 bold-text">{{ title }}</div>
			<p class="is-size-6" v-if="message"> {{ message }}</p>
			<br />
			<div class="has-text-right">
				<button class="button is-danger" @click="close(null)">Cancel</button>
				<button class="button is-primary ml-2" @click="close(true)">Yes</button>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { closeModal } from '@/utils/mixins';
import { defineComponent } from 'vue'

export default defineComponent({
	mixins: [closeModal],
	setup () {
		return {}
	},
	computed: {
		title () : string {
			return this.modalData.confirmation?.title || "Are you Sure";
		},
		message () : string {
			return this.modalData.confirmation?.message || '';
		}
	}
})
</script>

<style scoped>

</style>
